export default __webpack_public_path__ + "static/desert_bunker-05abea84102d23ff34d501a8f05e25fa.png";